import { render } from "preact";
import { App, AppHistory } from "./core";
import "./style/discovery.css";
import "./style/scrollbar.css";
import "./style/tailwind.css";

AppHistory.mount();

const app = App({});

render(app, document.body);
document.body.classList.remove("initial-load");
document.querySelector("body>#appPlaceholder")?.remove();
